<template>
    <div class="menu-container">
        <nav class="navbar navbar-expand-lg">
            <div class="container">
                <router-link :to="{name: 'index', params: {lang: def_lang}}">
                    <a class="navbar-brand d-block d-lg-none logo">
                        <img :src="G.systemData?.logo?.value" alt="..." />
                    </a>
                </router-link>
                <div class="d-block d-lg-none h5">
                    {{ G.projectName }}
                </div>
                <!-- <a :href="`/${def_lang}`" class="d-none d-sm-block logo"><img :src="G.systemData?.logo?.value" alt="..." /></a> -->

                <button
                    class="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarContent"
                    aria-controls="navbarContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <i class="fas fa-bars fs-1"></i>
                </button>

                <div class="collapse navbar-collapse" id="navbarContent">
                    <router-link :to="{name: 'index', params: {lang: def_lang}}">
                        <a class="d-none d-lg-block logo"><img :src="G.systemData?.logo?.value" alt="..." /></a>
                    </router-link>

                    <ul class="navbar-nav mt-2 mt-sm-0 me-auto d-flex-sm align-items-lg-center">
                        <MenuItem v-if="data.length > 0" :data="data[0]" />
                        <MenuItem :data="categories" class="pt-1" />
                        <MenuItem v-for="item in data.slice(1)" :key="item.id" :data="item" />
                    </ul>

                    <!-- <div class="navbar-nav text-nowrap d-flex-sm align-items-sm-center">
                        <a
                            class="nav-link me-3 position-relative"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                            aria-controls="offcanvasNavbar"
                            aria-expanded="false"
                        >
                            <i class="far fa-heart"></i>
                            <span v-if="favorites.length" class="position-absolute badge top-0 start-1 bg-warning rounded-circle">
                                <span>{{ favorites.length || '' }}</span>
                                <span class="visually-hidden">Favorite</span>
                            </span>
                        </a>

                    </div> -->

                    <div class="col-12 col-lg-2 mb-3 mb-lg-0 text-center1 text-lg-end">
                        <div class="input-group">
                            <input
                                v-model="searchText"
                                type="search"
                                class="form-control form-sm-control fs-6 rounded-start-3"
                                :placeholder="TR.search"
                                aria-label="Search"
                                @keyup="onInputEnter"
                            />
                            <button @click="searchButton" class="btn btn-secondary bg-site rounded-end-3">
                                <i class="fas fa-search"></i>
                            </button>
                        </div>
                    </div>

                    <div v-if="langs.length > 1" class="navbar-nav dropdown mb-3 mb-lg-0 ms-sm-3">
                        <a href="#" class="dropdown-toggle lang-flag text-uppercase fw-bold text-dark" data-bs-toggle="dropdown" aria-expanded="false">
                            <!-- {{ $route.params.lang !== undefined ? langs.filter(e => e.shortname == $route.params.lang)[0]?.flag : '' }} -->
                            <img :src="`/assets/images/flags/${$route.params.lang}.png`" style="width: 24px;" class="me-1" />
                            {{ $route.params.lang !== undefined ? $route.params.lang : '' }}
                        </a>
                        <ul class="dropdown-menu" style="">
                            <li class="nav-item" v-for="(l, lind) in langs" :key="lind">
                                <a class="nav-link ps-3 cursor-pointer lang-flag text-uppercase fw-bold" @click="changeLang(l.shortname)">
                                    <img :src="`/assets/images/flags/${l.shortname}.png`" style="width: 24px;" class="me-1" />
                                    {{ l.shortname }}
                                </a>
                                <!-- <a class="nav-link ps-3 cursor-pointer" @click="changeLang(l.shortname)">{{ l.flag }} {{ l.shortname }}</a> -->
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </nav>
    </div>
</template>


<script>
    import { ref } from "vue";

    import { useRoute, useRouter } from "vue-router";
    import { useStore } from "@/system_modules/store";

    import { G } from "@/_common";

    import MenuItem from '@/components/navbar/MenuItem';

    export default {
        name: "NavbarC",
        components: {
            MenuItem,
        },
        props:{
            categories:{
                type: Object,
                default: () => {}
            },
            data:{
                type: Array,
                default: () => []
            },
            favorites:{
                type: Array,
                default: () => []
            },
            TR:{
                type: Object,
                default: () => {}
            },
            langs:{
                type: Array,
                default: () => []
            },
        },
        setup() {
            const store = useStore();
            const route = useRoute();
            const router = useRouter();

            const def_lang = store.getLang();

            const searchText = ref("");

            searchText.value = route.params && route.params.search_text && route.params.search_text != '0' ? route.params.search_text : '';

            const changeLang = (lang) => {
                // const result = text.replace(/B/g, match => ++t === 2 ? 'Z' : match)
                // window.location.href = '//' + window.location.host + '' + route.path.replace(/^\/([a-z]{2})(\/)?/, `/${lang}$2`);
                window.location.href = route.path.replace(/^\/([a-z]{1,3})(\/)?/, `/${lang}$2`);
            };

            const searchButton = () => {
                if( searchText.value.length > 1 ){
                    router.push({
                        name: 'post_paging',
                        params: {
                            page: 1,
                            perpage: G.rowsPerPage,
                            category_id: 0,
                            // author_id: 0,
                            // sortfield: 'create_date',
                            // sortorder: 1,
                            // filters: '0',
                            search_text: searchText.value || '',
                        },
                        // query: {
                        //     search_text: searchText.value,
                        // }
                    });
                }
            };

            const onInputEnter = (e) => {
                if (e.which == 13) {
                    searchButton();
                }
            };

            return {
                G,
                def_lang,
                changeLang,
                searchText,
                searchButton,
                onInputEnter,
            };
        },
    };
</script>

<style lang="scss" scoped>
.menu-container .navbar {
    // background-color: rgb(var(--site-primary-color-rgb));
    // background: linear-gradient(to top, rgba(200, 200, 200, 0.5), transparent);
    background: linear-gradient(to bottom, rgba(var(--site-primary-color-rgb), 0.5), transparent);
    position: fixed;
    z-index: 1000;
    width: 100%;
    // background-color: transparent;
    // height: 100px;
    transition: height 0.3s, background-color 0.3s;
}
.menu-container .logo img {
    height: 80px;
    // margin-right: 40px;
    transition: height 0.3s;
}
.menu-container.fix-menu-container .navbar{
    background-color: #ffffff;
    // border-bottom: 1px solid var(--default-color);
}
.menu-container.fix-menu-container .logo img{
    height: 60px;
}
.navbar-brand{
    margin-right: unset;
}
.lang-flag img{
    filter: grayscale(80%);
}
.input-group {
    display: inline-flex;
    width: unset;
}
// .input-group > .form-control, .input-group > .form-floating, .input-group > .form-select {
//     width: 180px;
// }
@media (max-width: 820px) {
    .menu-container{
        background-color: #ffffff;
        height: 60px;
    }
    .menu-container .navbar{
        background: #ffffff;
    }
    .menu-container.fix-menu-container .navbar{
        // height: 60px;
        background-color: unset;
        border-bottom: unset;
    }
    // .menu-container.fix-menu-container .logo img{
    //     height: unset;
    // }
    .menu-container .navbar{
        // position: relative;
        height: 60px;
        position: relative;
        // z-index: 1000;
        width: 100%;
    }
    .menu-container .navbar .container{
        background-color: #ffffff;
    }
    .menu-container .logo img {
        transition: none;
        height: 32px;
    }
//     .menu-container.fix-menu-container .navbar .container{
//         background-color: #ffffff;
//     }
}
</style>
